import { Attrs, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'lvcEventStatus', {
  cancelled: 'Événement<br>annulé',
  postponed: 'Événement<br>reporté',
  rescheduled: 'Nouvelle<br>date',
})
Locale.getInstance().registerKeySet('en', 'lvcEventStatus', {
  cancelled: 'Event<br>cancelled',
  postponed: 'Event<br>postponed',
  rescheduled: 'New<br>date',
})

export enum EventStatus {
  Cancelled = 'Cancelled',
  Postponed = 'Postponed',
  Rescheduled = 'Rescheduled',
}

export interface LvcEventStatus {
  status: EventStatus
}

export class LvcEventStatus extends MinzeElement {
  attrs: Attrs = ['status']
  renderIcon = (status: EventStatus) => {
    switch (status) {
      case EventStatus.Cancelled:
        return cancelledIcon
      case EventStatus.Postponed:
        return postponedIcon
      case EventStatus.Rescheduled:
        return rescheduledIcon
      default:
        return ''
    }
  }
  getTextLabel = (status: EventStatus) => {
    switch (status) {
      case EventStatus.Cancelled:
        return Locale.getKey('lvcEventStatus.cancelled')
      case EventStatus.Postponed:
        return Locale.getKey('lvcEventStatus.postponed')
      case EventStatus.Rescheduled:
        return Locale.getKey('lvcEventStatus.rescheduled')
      default:
        return ''
    }
  }
  html = () => `
    ${
      this.status
        ? `
      ${this.renderIcon(this.status)}
      <div class="lvc-event-status__text">
        ${this.getTextLabel(this.status)}
      </div>
    `
        : ''
    }
 
  `
  css = () => `
    :host {
      background-color: ${this.status === EventStatus.Cancelled || this.status === EventStatus.Postponed ? '#FF4600' : this.status === EventStatus.Rescheduled ? '#DCFFD7' : 'none'};
      color: ${this.status === EventStatus.Cancelled || this.status === EventStatus.Postponed ? '#FFFFFF' : '#1E007D'};
      display: ${this.status ? 'flex' : 'none'};
      gap: 4px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 67px;
      height: 67px;
      border-radius: 100%;
      font-size: 8px;
      line-height: 1.1;
    }

  `
}

const postponedIcon = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.47531 3.64817C1.24668 3.48416 1.12243 3.37978 0.988236 3.29529C0.839131 3.20085 0.680087 3.19091 0.526013 3.29529C0.347088 3.41457 0.217864 3.58355 0.267566 3.7923C0.451461 4.56764 0.734759 5.31316 1.23674 5.94437C1.45046 6.21773 1.78346 6.30719 2.13634 6.17797C2.23077 6.14317 2.33514 6.12826 2.41466 6.07359C3.18504 5.56167 3.95044 5.04478 4.71087 4.51794C4.81027 4.44836 4.86494 4.30919 4.93452 4.20979C4.84009 3.82212 4.57667 3.70284 4.25859 3.7923C3.94547 3.87679 3.64726 4.03087 3.34905 4.17997C3.0906 4.3092 2.8421 4.46327 2.51904 4.64717C2.39975 4.06566 2.56377 3.60841 2.7079 3.15116C2.86695 2.66905 3.16019 2.27144 3.56277 1.95832C4.54188 1.20286 6.46533 0.85495 7.80229 1.99311C9.0995 3.09648 9.86987 4.47818 10.1283 6.13821C10.3023 7.25152 10.0239 8.31513 9.49214 9.29425C9.02495 10.1491 8.21978 10.5467 7.30528 10.6759C5.82915 10.8797 4.40272 10.6213 3.05084 9.99503C2.46437 9.72168 1.98723 9.32406 1.97729 8.57854C1.97729 8.49405 1.81825 8.35489 1.71885 8.34495C1.6095 8.33501 1.4604 8.40956 1.38088 8.49405C1.11249 8.80717 1.12243 9.18987 1.28644 9.5179C1.4604 9.86581 1.69399 10.2088 1.98226 10.4622C2.30035 10.7406 2.68802 10.9543 3.08066 11.1233C4.18403 11.6004 5.35699 11.834 6.55479 11.834C7.10647 11.834 7.67804 11.7346 8.20985 11.5805C9.42256 11.2276 10.2675 10.4423 10.7396 9.24951C11.7585 6.67995 11.1671 4.37878 9.54681 2.27641C9.1492 1.75951 8.63231 1.31717 8.10547 0.924532C5.94346 -0.700703 2.24071 0.402667 1.59956 3.16109C1.58465 3.30026 1.54489 3.41954 1.47531 3.64817Z" fill="white"/>
</svg>
`
const cancelledIcon = `
<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.39067 0.833008C1.39067 0.833008 -0.636923 11.9473 2.52202 11.9473C3.17094 11.9473 5.60911 11.9789 5.60911 11.9789C5.60911 11.9789 8.20092 11.9651 9.47417 11.9651C11.0021 11.9651 13.3474 13.0013 12.6102 10.3709C11.806 7.50097 11.9273 4.21247 11.7574 1.32777C11.7303 0.866284 2.89936 1.32777 1.76787 0.833008" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
<path d="M3.4165 4.16602C4.64363 4.42053 5.30124 6.33588 6.4165 6.91416C7.4461 7.44803 8.42828 8.21779 9.4165 8.83268" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
<path d="M4.0835 9.49935C4.87951 9.41585 6.12223 7.37097 6.53964 6.76827C7.19995 5.81483 8.09841 5.08899 8.75016 4.16602" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
</svg>
`
const rescheduledIcon = `
<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.5459 1.86764L12.9995 2.03531M13.1331 1.9852C13.3648 2.80941 13.5674 3.76151 13.5741 4.61763C13.5741 4.63856 13.5697 4.65904 13.5616 4.67788C13.5602 4.71625 13.5444 4.75276 13.5172 4.78C13.4886 4.80853 13.4499 4.82456 13.4096 4.82456L1.6272 4.72719C1.58685 4.72719 1.54815 4.71115 1.51962 4.68262C1.49836 4.66137 1.48404 4.63447 1.47812 4.60545C1.47228 4.58934 1.46901 4.57111 1.46901 4.55074C1.49336 3.72914 1.47154 2.78266 1.42285 1.96106M10.4305 5.31336C10.5484 4.37296 10.51 2.30793 10.4305 1.1987M4.17657 1.09182L4.30348 5.27996M13.0919 12.5844L1.82494 12.3111C1.8068 12.3185 1.78721 12.3224 1.76723 12.3224C1.72687 12.3224 1.68817 12.3064 1.65964 12.2779C1.63111 12.2493 1.61508 12.2106 1.61508 12.1703C1.69622 10.2025 1.69768 8.07093 1.61654 6.09908M12.9897 12.4458C12.9916 10.3431 13.0648 8.13241 13.227 6.04174C13.227 5.91792 13.1183 5.87275 13.0307 5.90195C9.30058 5.9708 5.41777 5.9938 1.69173 5.95325" stroke="#1E007D" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`
